__turbopack_context__.v({
  "areaLabel": "RedesignTelepulesek-module__oHgyHG__areaLabel",
  "cityCard": "RedesignTelepulesek-module__oHgyHG__cityCard",
  "cityCardActive": "RedesignTelepulesek-module__oHgyHG__cityCardActive",
  "cityCounty": "RedesignTelepulesek-module__oHgyHG__cityCounty",
  "cityIcon": "RedesignTelepulesek-module__oHgyHG__cityIcon",
  "cityName": "RedesignTelepulesek-module__oHgyHG__cityName",
  "cityTag": "RedesignTelepulesek-module__oHgyHG__cityTag",
  "cityTags": "RedesignTelepulesek-module__oHgyHG__cityTags",
  "cityTop": "RedesignTelepulesek-module__oHgyHG__cityTop",
  "comingCard": "RedesignTelepulesek-module__oHgyHG__comingCard",
  "comingIcon": "RedesignTelepulesek-module__oHgyHG__comingIcon",
  "comingName": "RedesignTelepulesek-module__oHgyHG__comingName",
  "comingSection": "RedesignTelepulesek-module__oHgyHG__comingSection",
  "comingSub": "RedesignTelepulesek-module__oHgyHG__comingSub",
  "ctaBtn": "RedesignTelepulesek-module__oHgyHG__ctaBtn",
  "ctaStrip": "RedesignTelepulesek-module__oHgyHG__ctaStrip",
  "ctaText": "RedesignTelepulesek-module__oHgyHG__ctaText",
  "eyebrow": "RedesignTelepulesek-module__oHgyHG__eyebrow",
  "eyebrowDot": "RedesignTelepulesek-module__oHgyHG__eyebrowDot",
  "footer": "RedesignTelepulesek-module__oHgyHG__footer",
  "footerBrand": "RedesignTelepulesek-module__oHgyHG__footerBrand",
  "footerCopy": "RedesignTelepulesek-module__oHgyHG__footerCopy",
  "footerLinks": "RedesignTelepulesek-module__oHgyHG__footerLinks",
  "footerLogo": "RedesignTelepulesek-module__oHgyHG__footerLogo",
  "mainBody": "RedesignTelepulesek-module__oHgyHG__mainBody",
  "mapArea": "RedesignTelepulesek-module__oHgyHG__mapArea",
  "mapSvg": "RedesignTelepulesek-module__oHgyHG__mapSvg",
  "mapWrap": "RedesignTelepulesek-module__oHgyHG__mapWrap",
  "pageHeader": "RedesignTelepulesek-module__oHgyHG__pageHeader",
  "pageSub": "RedesignTelepulesek-module__oHgyHG__pageSub",
  "pageTitle": "RedesignTelepulesek-module__oHgyHG__pageTitle",
  "sidebar": "RedesignTelepulesek-module__oHgyHG__sidebar",
  "sidebarLabel": "RedesignTelepulesek-module__oHgyHG__sidebarLabel",
  "site": "RedesignTelepulesek-module__oHgyHG__site",
  "statCard": "RedesignTelepulesek-module__oHgyHG__statCard",
  "statLabel": "RedesignTelepulesek-module__oHgyHG__statLabel",
  "statValue": "RedesignTelepulesek-module__oHgyHG__statValue",
  "statsRow": "RedesignTelepulesek-module__oHgyHG__statsRow",
});
